import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { useDispatch } from "react-redux";

import TractionAI from "modules/tractionAI/AIMainComponent";
import { tractionAIMainStyles } from "modules/tractionAI/constants";
import { AISelectScreen } from "modules/tractionAI/store/tractionAI.actions";
import AIModalHeader from "modules/tractionAI/AIModalHeader";
import AIModalFooter from "modules/tractionAI/AIModalFooter";

const AIModalWrapper = ({ selectedCouncil }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const handleShowMore = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);

    dispatch(AISelectScreen({
      applyNoAnimationLogic: true,
    }));
  }

  return (
    <>
      <div
        className="mr-3 small cursor-pointer"
        style={tractionAIMainStyles.title}
        onClick={handleShowMore}
      >
        Traction AI
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="lg"
        disableEscapeKeyDown
        scroll="paper"
      >
        <AIModalHeader handleClose={handleClose} />
        <TractionAI selectedCouncil={selectedCouncil} />
        <AIModalFooter />
      </Dialog>
    </>
  )
}

export default React.memo(AIModalWrapper);
